"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _Mattermost = /*#__PURE__*/ _interop_require_default(require("./Mattermost"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let MattermostPlugin = class MattermostPlugin extends _ncplugin.XcWebhookNotificationPlugin {
    getAdapter() {
        return MattermostPlugin.notificationAdapter;
    }
    async init(_config) {
        MattermostPlugin.notificationAdapter = new _Mattermost.default();
        await MattermostPlugin.notificationAdapter.init();
    }
};
const _default = MattermostPlugin;
